import { z } from "zod";
import { organizationNameField, socialUrlField } from "@core/schemas/fields";

/**
 * Schema for the organization profile form.
 * Composes reusable field schemas from @core/schemas/fields.
 */
export const organizationProfileFormSchema = z.object({
  name: organizationNameField,
  instagram_url: socialUrlField,
  facebook_url: socialUrlField,
  tiktok_url: socialUrlField,
  bluesky_url: socialUrlField,
  linkedin_url: socialUrlField,
});

export type OrganizationProfileFormData = z.infer<
  typeof organizationProfileFormSchema
>;
